import { Box, IconButton, Switch, Tooltip } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
// import {
//   useLazyDeleteCustomerQuery,
//   useLazyGetCustomersQuery,
//   useUpdateStatusCustomerMutation,
// } from "";
import { ROLES } from "../../utils/enums";
import { SubAdmin, SubAdminResponse } from "../../types/General";
import { showError, showToast } from "../../constants/toasts";
import moment from "moment";
import { handleDelete } from "../../utils/commonFunctions";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import {
  useLazyDeleteSubadminQuery,
  useLazyGetSubAdminQuery,
  useUpdateStatusSubAdminMutation,
} from "../../services/accessRole";
import useTranslation from "../../hooks/traslation";

const SubadminList = ({
  debouncedSearchTerm,
}: {
  debouncedSearchTerm: string;
}) => {
  const navigate = useNavigate();
  const translation = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState<number>(1);
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [openDelete, setOpenDelete] = useState(false);
  const [rows, setRows] = useState<SubAdminResponse[]>([]);
  const [getCustomers] = useLazyGetSubAdminQuery();
  const [updateStatus] = useUpdateStatusSubAdminMutation();
  const [deleteCustomer] = useLazyDeleteSubadminQuery();

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 180,
      field: "name",
      headerName: translation.globals.name,
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            className="user_block click_action"
            onClick={() => navigate(`/manage-subadmin/detail/${row._id}`)}
          >
            <figure>
              <img
                src={
                  row?.image
                    ? row?.image
                    : `/static/images/user_placeholder.png`
                }
                alt=""
              />
            </figure>
            <Tooltip title={row?.name || ""} arrow>
              <p>
                <b>{row?.name || ""}</b>
              </p>
            </Tooltip>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "email",
      headerName: translation.user.Email,
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 180,
      field: "phone",
      headerName: translation.auth.phone,
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p>
            {row?.dialCode || ""} {row?.phoneNo || ""}
          </p>
        );
      },
    },
    // {
    //   flex: 1,
    //   minWidth: 150,
    //   field: "acceessRole",
    //   headerName: "Role",
    //   editable: false,
    //   sortable: false,
    //   renderCell: ({ row }) => {
    //     return (
    //       //@ts-ignore
    //       <p>{row.acceessRole?.[0].name}</p>
    //     );
    //   },
    // },
    {
      flex: 1,
      minWidth: 150,
      field: "createdAt",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p>
            <b>{moment(row?.createdAt).format("YYYY-MM-DD")}</b>
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "status",
      headerName: translation.globals.status,
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            checked={!row?.isBlocked}
            onChange={() => handleStatusUpdate(row?._id, !row?.isBlocked)}
          />
        );
      },
    },
    {
      minWidth: 130,
      field: "action",
      headerName: translation.globals.actions,
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <Tooltip title="View" arrow>
                <IconButton
                  onClick={() =>
                    navigate(`/manage-subadmin/detail/${row?._id}`)
                  }
                >
                  <img src="/static/images/eye_icon.svg" alt="View" />
                </IconButton>
              </Tooltip>
            </Box>

            <Box>
              <Tooltip title="Edit" arrow>
                <IconButton
                  onClick={() => navigate(`/manage-subadmin/edit/${row?._id}`)}
                >
                  <img src="/static/images/edit2_icon.svg" alt="Edit" />
                </IconButton>
              </Tooltip>
            </Box>

            <Box>
              <Tooltip title="Delete" arrow>
                <IconButton
                  onClick={() => {
                    setSelectedId(row?._id);
                    setOpenDelete(true);
                  }}
                >
                  <img src="/static/images/trash2_icon.svg" alt="Delete" />
                </IconButton>
              </Tooltip>
            </Box>
          </div>
        );
      },
    },
  ];

  const handleStatusUpdate = async (id: string, status: boolean) => {
    const body = {
      isBlocked: status,
    };

    try {
      const response = await updateStatus({ id, body }).unwrap();
      if (response?.statusCode === 200) {
        getAllSubAdmin();
        if (status === true) {
          showToast(translation.error.subAdminDeactivated);
        } else {
          showToast(translation.error.subAdminActivated);
        }
      } else {
        showError(translation.error.tryAgain);
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };
  const getAllSubAdmin = async () => {
    setIsLoading(true);
    try {
      const response = await getCustomers({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setRows(response?.data?.list || []);
        setCount(response?.data?.totalCount);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleDelete = async () => {
    setIsLoading(true);

    try {
      const response = await deleteCustomer({ id: selectedId }).unwrap();
      setIsLoading(false);

      if (response?.statusCode === 200) {
        showToast(translation.error.subAdminDeleted);
        if (rows.length === 1 && page > 1) {
          setPage(page - 1);
        } else {
          getAllSubAdmin();
        }
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setIsLoading(false);
    } finally {
      getAllSubAdmin();
    }
  };

  useEffect(() => {
    getAllSubAdmin();
  }, [debouncedSearchTerm]);

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={handlePageChange}
          loading={isLoading}
        />
      </div>
      <ConfirmationModal
        text={translation.error.SubAdminWarn}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />
    </>
  );
};

export default SubadminList;
